export class RiderPhotoApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The photo, the market's rule and what the next ride request says. */
    get(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/rider/photo${marketId !== undefined && marketId !== '' ? `?marketId=${encodeURIComponent(marketId)}` : ''}`, auth: true });
    }
    /** A new photo (it replaces the current one). */
    upload(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider/photo', body: input, auth: true });
    }
}
export class AdminRiderPhotoApi {
    client;
    constructor(client) {
        this.client = client;
    }
    get(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/rider-photo`, auth: true });
    }
    /** The image (audited before it leaves the server). */
    image(userId, photoId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/rider-photo/${encodeURIComponent(photoId)}/image`, auth: true });
    }
    /** Propose rejecting the current photo (the maker). */
    reject(userId, photoId, input) {
        return this.client.request({ method: 'POST', path: `/v1/ops/users/${encodeURIComponent(userId)}/rider-photo/${encodeURIComponent(photoId)}/rejections`, body: input, auth: true });
    }
    /** Approve or decline another operator's proposal (the checker). */
    decide(userId, rejectionId, approve) {
        return this.client.request({ method: 'POST', path: `/v1/ops/users/${encodeURIComponent(userId)}/rider-photo/rejections/${encodeURIComponent(rejectionId)}/decision`, body: { approve }, auth: true });
    }
}
//# sourceMappingURL=rider-photo.js.map